import React, { useState, useEffect } from 'react';
import { Badge, Spinner } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle, FaKey, FaClock } from 'react-icons/fa';
import axios from 'axios';

const LicenseStatusBadge = () => {
  const [licenseStatus, setLicenseStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLicenseStatus();
  }, []);

  const fetchLicenseStatus = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/license/status', {
        headers: { 'x-auth-token': token }
      });
      setLicenseStatus(response.data);
    } catch (err) {
      console.error('Error fetching license status:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Badge bg="secondary" style={{ cursor: 'pointer', padding: '8px 12px' }}>
        <Spinner animation="border" size="sm" className="me-1" />
        Checking...
      </Badge>
    );
  }

  if (!licenseStatus) {
    return (
      <Badge bg="secondary" style={{ cursor: 'pointer', padding: '8px 12px' }}>
        <FaKey className="me-1" />
        Unknown
      </Badge>
    );
  }

  const getBadgeContent = () => {
    switch (licenseStatus.status) {
      case 'ACTIVE':
        // Show days remaining if 14 or less
        if (licenseStatus.daysRemaining <= 14) {
          return (
            <Badge 
              bg={licenseStatus.daysRemaining <= 3 ? 'danger' : licenseStatus.daysRemaining <= 7 ? 'warning' : 'success'} 
              style={{ cursor: 'pointer', padding: '8px 12px' }}
              title="Click to manage license"
            >
              <FaClock className="me-1" />
              {licenseStatus.daysRemaining} days left
            </Badge>
          );
        }
        return (
          <Badge bg="success" style={{ cursor: 'pointer', padding: '8px 12px' }} title="Click to manage license">
            <FaCheckCircle className="me-1" />
            Active
          </Badge>
        );
      case 'EXPIRED':
        return (
          <Badge bg="danger" style={{ cursor: 'pointer', padding: '8px 12px' }} title="Click to manage license">
            <FaExclamationTriangle className="me-1" />
            Expired
          </Badge>
        );
      case 'NO_LICENSE':
        return (
          <Badge bg="warning" style={{ cursor: 'pointer', padding: '8px 12px' }} title="Click to enter license">
            <FaKey className="me-1" />
            No License
          </Badge>
        );
      default:
        return (
          <Badge bg="secondary" style={{ cursor: 'pointer', padding: '8px 12px' }}>
            <FaKey className="me-1" />
            Unknown
          </Badge>
        );
    }
  };

  return getBadgeContent();
};

export default LicenseStatusBadge;
